import moment from 'moment'
import { useAuthStore } from '@/stores/auth'
import { useTheme } from '@/composables/theme'
import { AnalyticsBrowser } from '@segment/analytics-next'
import { VueCookieNext } from 'vue-cookie-next'

export const getSavedState = (key) => {
  const { getDomain } = useTheme()
  const domain = getDomain()

  if (!domain) return

  const parsedKey = `${key}---${domain}`

  const expiresAt = localStorage.getItem(`cache-${parsedKey}`)
  if (expiresAt && expired(expiresAt)) {
    localStorage.removeItem(`cache-${parsedKey}`)
    localStorage.removeItem(parsedKey)
    VueCookieNext.removeCookie(parsedKey)
    return null
  }

  if (localStorage.getItem(parsedKey) != null && localStorage.getItem(parsedKey) !== 'undefined') {
    return JSON.parse(localStorage.getItem(parsedKey))
  }

  return VueCookieNext.getCookie(parsedKey)
}

//expiresAt is expired if it is set and in the past
function expired(expiresAt) {
  return expiresAt && moment().isSameOrAfter(expiresAt)
}

export const saveState = (key, state, expiresAt) => {
  const { getDomain } = useTheme()
  const domain = getDomain()

  if (!domain) return

  const parsedKey = `${key}---${domain}`

  if (expiresAt) {
    localStorage.setItem(`cache-${parsedKey}`, expiresAt.format())
  }

  localStorage.setItem(parsedKey, JSON.stringify(state))
}

export function getHarnessId() {
  const authStore = useAuthStore()
  return authStore.getVerifiedTokenClaims?.harness_id || null
}

export const clearAuth = () => {
  const { getDomain } = useTheme()
  const domain = getDomain()

  if (!domain) return

  removeDomainLocalStorageKeys(domain)
  localStorage.clear()
  VueCookieNext.removeCookie('auth.Token')
}

export const getAllLocalStorageKeys = () => Object.keys(localStorage)

export const removeLocalStorageKeys = (keys) => {
  keys.forEach((key) => {
    localStorage.removeItem(key)
  })
}

export const removeDomainLocalStorageKeys = (domain) => {
  const parsedDomain = `---${domain}`

  const keys = getAllLocalStorageKeys()
  const filteredKeys = keys.filter((key) => key.includes(parsedDomain))

  removeLocalStorageKeys(filteredKeys)
}

export const getAllCookies = () => VueCookieNext.keys()

export const removeDomainCookieKeys = (domain) => {
  const parsedDomain = `---${domain}`

  getAllCookies().forEach((cookie) => {
    if (cookie.includes(parsedDomain)) {
      VueCookieNext.removeCookie(cookie, {
        path: `/${domain}`
      })
    }
  })
}

export const isExpired = (month, year) => {
  if (parseInt(year) < new Date().getFullYear()) {
    return true
  }
  if (parseInt(year) === new Date().getFullYear()) {
    if (parseInt(month) < new Date().getMonth() + 1) {
      return true
    }
  }
  return false
}

export const isDecimal = (num) => {
  return num % 1
}

export const analyticsInitialize = () => {
  window.analytics = new AnalyticsBrowser()
  window.analytics
    .load({ writeKey: import.meta.env.VITE_APP_SEGMENT_KEY })
    .catch((error) => console.error(error))
}

export const getDefaultCampaign = (
  image,
  description = 'Donations will go to the area needed most'
) => {
  return {
    id: 0,
    name: 'Area of Greatest Need',
    description: description,
    image,
    categories: [{ name: 'About Us' }]
  }
}
